import { Locale, Occupation } from "lib/build/concepts";

export interface User {
	id: string;
	avatarUrl: string;
	title: string;
	firstName: string;
	lastName: string;
	email: string;
	defaultLanguage: Locale | "";
	permissions: {
		organization: string;
		module: string;
		permission: Permission;
	}[];
	occupation: Occupation;
	fullstoryOrgId: string;
	lastViewedMessage: string;
	coworkers: Coworker[];
}

export interface Coworker {
	id: string;
	title: string;
	firstName: string;
	lastName: string;
}

export enum Permission {
	UsersRW = "J",
	UsersR = "K",

	PatientsNew = "G",
	PatientsAllRW = "H",
	PatientsAllR = "I",

	Timeline = "L",
	LimitedAccessFormRW = "N",
	Stats = "M"
}

export enum AuthType {
	EmailPassword = "EMAIL_PASSWORD",
	Passwordless = "PASSWORDLESS",
	TwoFactor = "2_FACTOR"
}
